import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import '../styles/TableCellOrder.scss';

const isActiveOrderingAsc = (orderName, ordering) => orderName === ordering;
const isActiveOrderingDesc = (orderName, ordering) => `-${orderName}` === ordering;

function getClassName(orderName, ordering) {
    if (isActiveOrderingAsc(orderName, ordering)) {
        return 'asc';
    }
    else if (isActiveOrderingDesc(orderName, ordering)) {
        return 'desc';
    }
    else return '';
}

function getOrdering(orderName, ordering) {
    if (ordering === orderName) {
        return `-${orderName}`;
    }
    else if (ordering === `-${orderName}`) {
        return orderName;
    }
    else {
        return orderName;
    }
}

const TableCellOrder = (props) => {
    const urlSearchParams = new URLSearchParams(props.history.location.search);

    const handleClick = () => {
        urlSearchParams.set('ordering', getOrdering(props.orderName, props.ordering));
        if (urlSearchParams.get('page')) {
            urlSearchParams.set('page', '1');
        }
        props.history.push({search: urlSearchParams.toString()});
    };

    return (
        <TableCell className={`table-cell-order ${props.className}`}>
            <div>
                {props.children}
                <div className={`order ${getClassName(props.orderName, props.ordering)}`}>
                    <IconButton size="small"
                                onClick={
                                    (props.onClick)
                                        ? () => props.onClick(getOrdering(props.orderName, props.ordering))
                                        : handleClick
                                }
                    >
                        <ArrowDropUpIcon className="asc"/>
                        <ArrowDropDownIcon className="desc" />
                    </IconButton>
                </div>
            </div>
        </TableCell>
    );
};

TableCellOrder.propTypes = {
    className: PropTypes.string,
    orderName: PropTypes.string,
    ordering: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};

TableCellOrder.defaultProps = {
    className: '',
};

let Component = TableCellOrder;
Component = withRouter(Component);

export default Component;
